/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { IdReferenceId } from './idReferenceId';

/**
 * Reference to an object by id
 */
export interface IdReference {
  id?: IdReferenceId;
}
